import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import DebitForm from './debit-form/debitForm';
import { KEY } from 'web/components/utils/stripeKey';
import styles from './debit.module.scss';
const AddCard = ({ modalType, pageData, callBackFetchApi, callBackModal, props, callBack, pageLanguageContents }) => {
  const stripePromise = loadStripe(KEY);
  return (
    <div className='col-12 p-0'>
      <div className={styles.body}>
        <Elements stripe={stripePromise}>
          <DebitForm
            pageData={pageData}
            modalType={modalType}
            props={props}
            callBackModal={callBackModal}
            callBackFetchApi={callBackFetchApi}
            callBack={() => {
              callBack()
            }}
            pageLanguageContents={pageLanguageContents} />
        </Elements>
      </div>
    </div>
  );
};
export default AddCard;
